import type { DeepNonNullable } from '@zen/utils/typescript';

import type { Time } from '../types';
import { isParseableAsTime } from './parsing';

export const isValidTime = (time: Time | string): boolean => isParseableAsTime(time);

export const hasTime = (time: Time): time is DeepNonNullable<Time, 'minute hour'> => time.hour !== null && time.minute !== null;
